module.exports = __webpack_public_path__ + "img/all.86140042.jpg";